import React from 'react';
import { ReactComponent as CasinoIcon } from '../assets/icons/casino.svg'
import { ReactComponent as SportIcon } from '../assets/icons/sport.svg';
import { ReactComponent as LotteryIcon } from '../assets/icons/lottery.svg';
import { ReactComponent as PromotionsIcon } from '../assets/icons/promotions.svg';
import { ReactComponent as Slot } from '../assets/icons/slot.svg';
import { ReactComponent as Table } from '../assets/icons/table.svg';
import { ReactComponent as Blackjack } from '../assets/icons/blackjack.svg';
import { ReactComponent as Baccarat } from '../assets/icons/baccarat.svg';
import { ReactComponent as Roulette } from '../assets/icons/roulette.svg';
import { ReactComponent as Poker } from '../assets/icons/poker.svg';
import { ReactComponent as MiniGame } from '../assets/icons/miniGame.svg';
import { ReactComponent as Live } from '../assets/icons/live.svg';
import { ReactComponent as Plinko } from '../assets/icons/plinko.svg';
import { ReactComponent as Home } from '../assets/icons/home.svg';
import { ReactComponent as VipIcon } from '../assets/icons/vip.svg';
import { ReactComponent as BonusIcon } from '../assets/icons/bonus.svg';
import { ReactComponent as ResponsibleIcon } from '../assets/icons/responsible.svg';
import { ReactComponent as FavoritesIcon } from '../assets/icons/favorites.svg';
import { ReactComponent as RaffleIcon } from '../assets/icons/raffle.svg';
import { ReactComponent as SupportIcon } from '../assets/icons/support.svg';


export const menuItems = [
  {
    id: 'casino',
    labelKey: 'nav.casino',
    icon: <CasinoIcon />,
    context: [
      {
        id: 'All',
        labelKey: 'nav.lobby',
        icon: <Home  />,
      },
      {
        id: 'SLOT',
        labelKey: 'nav.slots',
        icon: <Slot />,
      },

      {
        id: 'Blackjack',
        labelKey: 'nav.blackjack',
        icon: <Blackjack />,
      },
      {
        id: 'Baccarat',
        labelKey: 'nav.baccarat',
        icon: <Baccarat />,
      },
      {
        id: 'Roulette',
        labelKey: 'nav.roulette',
        icon: <Roulette />,
      },
      {
        id: 'POKER',
        labelKey: 'nav.poker',
        icon: <Poker />,
      },
      // {
      //   id: 'LOTTERY',
      //   label: 'Lottery',
      //   icon: <LotteryIcon />,
      // },
      {
        id: 'LIVE',
        labelKey: 'nav.liveCasino',
        icon: <Live />,
      },
      {
        id: 'MINI_GAME',
        labelKey: 'nav.miniGame',
        icon: <MiniGame />,
      },
      {
        id: 'PLINKO',
        labelKey: 'nav.plinko',
        icon: <Plinko />,
      },
      {
        id: 'OTHER',
        labelKey: 'nav.other',
        icon: <CasinoIcon />,
      },
    ]
  },
  {
    id: 'sport',
    labelKey: 'nav.sports',
    icon: <SportIcon />,
    // context: [{
    //   id: 'sbo-sport',
    //   label: 'SBO Sport',
    // },
    // {
    //   id: 'sport',
    //   label: 'GG888 Sport',
    // },
    // ]
  },
  
  {
    id: 'LIVE',
    labelKey: 'nav.liveCasino',
    icon: <Live />,
  },
  {
    id: 'favorites',
    labelKey: 'nav.favorites',
    icon: <FavoritesIcon />,
  },
  {
    id: 'raffle',
    labelKey: 'nav.raffleDraws',
    icon: <RaffleIcon />,
  },
  // {
  //   id: 'promotions',
  //   label: 'Promotions',
  //   icon: (
  //     <PromotionsIcon />
  //   ),
  //   context: [{
  //     id: 'soccer',
  //     label: 'Soccer',
  //   },
  //   {
  //     id: 'tennis',
  //     label: 'Tennis',
  //   },
  //   {
  //     id: 'basketball',
  //     label: 'Basketball',
  //   }]
  // },
];

export const features =  {
  context: [
      {
        id: 'vip',
        labelKey: 'nav.vipClub',
        isVip: true,
        icon: <VipIcon  />,
      },
      {
        id: 'support',
        labelKey: 'nav.support',
        icon: <SupportIcon />,
      },
      {
        id: 'bonus',
        labelKey: 'nav.bonus',
        icon: <BonusIcon  />,
      },
      // {
      //   id: 'affiliate',
      //   label: 'Affiliate',
      //   icon: <AffiliateIcon  />,
      // },
      {
        id: 'responsible-gambling',
        labelKey: 'nav.responsibleGambling',
        icon: <ResponsibleIcon  />,
      },
]
}

